"use client";

import ErrorMessageView from "@/components/layout/error-message-view";
import { captureException } from "@sentry/nextjs";
import { useEffect } from "react";

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return <ErrorMessageView title={error.message} description="Please try again later." />;
}
